import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=46dc3724&scoped=true"
import script from "./charge.vue?vue&type=script&lang=js"
export * from "./charge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc3724",
  null
  
)

export default component.exports